<app-thread-sort-control (changeMessageOrder)="replySortingService.changeMessageOrder(false)">
</app-thread-sort-control>

<div class="d-flex flex-column" [ngClass]="{ 'one-time': commonDataService.isOneTime }">
    @if (ticket) {
        <div
            class="replies-block d-flex flex-column"
            [ngClass]="{
                'order-3': replySortingService.replySortBy !== parent.messagesOrderEnum.creationTimeAsc,
            }">
            <app-ticket-main-message
                class="ticket-block"
                [ticket]="ticket"
                [ngClass]="{ 'order-3': replySortingService.replySortBy !== parent.messagesOrderEnum.creationTimeAsc }">
            </app-ticket-main-message>
            <app-thread-expander
                class="print-hidden"
                [parent]="parent"
                [ticket]="ticket"
                [defaultCount]="10"
                [ngClass]="{ 'order-2': replySortingService.replySortBy !== parent.messagesOrderEnum.creationTimeAsc }">
            </app-thread-expander>

            @for (
                reply of ticket.messageThread
                    | filterReplies
                        : threadFilterService.collapseOptions
                        : replySortingService.replySortBy
                        : undefined
                        : undefined
                        : ticket.messageThread.length
                        : threadFilterService.updateStamp
                        : 10
                        : false;
                track reply
            ) {
                @if (!reply.isRemovedByFilter || reply.isTransparent) {
                    @if (reply.type === messageThreadElementTypeEnum.reply) {
                        <app-ticket-web-reply
                            class="ticket-block print-hidden"
                            id="reply-id-{{ reply.id }}"
                            [reply]="reply"
                            [quillConfig]="quillConfig">
                        </app-ticket-web-reply>
                    }

                    @if (reply.type === messageThreadElementTypeEnum.survey) {
                        <app-thread-survey-result
                            class="ticket-block print-hidden survey-block survey-block-web"
                            [threadElement]="reply"></app-thread-survey-result>
                    }

                    <!--
                        Auth thread messages should only be visible for chat tickets.
                        @if (reply.type === messageThreadElementTypeEnum.sessionAuthentication) {
                            <app-session-authentication-event
                                class="print-hidden"
                                [event]="reply"></app-session-authentication-event>
                        }
                    -->
                }
            }

            @if (threadFilterService.isPrinting) {
                <div style="display: none" class="ticket-thread-for-printing">
                    @for (
                        reply of threadFilterService.messageThreadForPrinting
                            | filterReplies
                                : threadFilterService.collapseOptions
                                : replySortingService.replySortBy
                                : undefined
                                : undefined
                                : ticket.messageThread.length
                                : threadFilterService.updateStamp
                                : 10
                                : true;
                        track reply
                    ) {
                        @if (!reply.isRemovedByFilter || reply.isTransparent) {
                            @if (reply.type === messageThreadElementTypeEnum.reply) {
                                <app-ticket-web-reply class="ticket-block" [reply]="reply" [quillConfig]="quillConfig">
                                </app-ticket-web-reply>
                            }

                            <!--
                                Auth thread messages should only be visible for chat tickets.
                                @if (reply.type === messageThreadElementTypeEnum.sessionAuthentication) {
                                    <app-session-authentication-event [event]="reply"></app-session-authentication-event>
                                }
                            -->
                        }
                    }
                </div>
            }
        </div>
    }

    @if (ticket.suggestions.length && parent.isShowFullReplyForm) {
        <app-suggestions
            [ngClass]="{ 'order-2': replySortingService.replySortBy !== parent.messagesOrderEnum.creationTimeAsc }"
            [suggestions]="ticket.suggestions">
        </app-suggestions>
    }

    @if (isSticky && replySortingService.replySortBy === parent.messagesOrderEnum.creationTimeAsc) {
        <div class="sticky-reply-background"></div>
    }
    @if (ticket.isTicketCanBeReplied) {
        <div
            id="reply-editor-container"
            class="new-reply ticket-message print-hidden ticket-block"
            (click)="
                (!parent.isForm && ticket.defaultReplyRecipients.cc.length) ||
                    parent.isShowFullReplyForm ||
                    parent.showFullReplyForm()
            "
            [ngClass]="{
                'order-1': replySortingService.replySortBy !== parent.messagesOrderEnum.creationTimeAsc,
                expanded: parent.isShowFullReplyForm,
                'top-0': !isSticky,
                sticky: isSticky,
            }">
            @if (isSticky && replySortingService.replySortBy !== parent.messagesOrderEnum.creationTimeAsc) {
                <div class="sticky-reply-background"></div>
            }
            @if (parent.isSendingReply) {
                <div class="ticket-blocker"></div>
            }
            <div>
                @if (!parent.isShowFullReplyForm) {
                    <div class="d-flex flex-row align-items-center">
                        <sb-user-avatar [user]="parent.user" [isNeedTooltip]="false"></sb-user-avatar>

                        @if (!ticket.defaultReplyRecipients.cc.length) {
                            <span class="cursor: pointer" style="line-height: 50px" translate> Write a reply </span>
                        } @else {
                            <span style="line-height: 50px">
                                <a (click)="parent.showFullReplyForm()" translate> Reply to all</a>
                                {{ 'or' | translate }}
                                <a (click)="parent.showFullReplyForm(true)" translate>Reply only to sender</a>
                            </span>
                        }
                    </div>
                } @else {
                    <div class="full-reply-form">
                        <div class="d-flex justify-content-end">
                            <button
                                class="btn btn-icon pin-button"
                                (click)="toggleStickyState()"
                                tooltip="{{ isSticky ? ('Unpin' | translate) : ('Pin' | translate) }}"
                                container="body">
                                @if (isSticky) {
                                    <sb-inline-svg class="icon" [url]="'/assets/images/unpin.svg'"></sb-inline-svg>
                                } @else {
                                    <sb-inline-svg class="icon" [url]="'/assets/images/pin.svg'"></sb-inline-svg>
                                }
                            </button>
                        </div>
                        @if (!isToAndCcHidden) {
                            <div class="reply-emails-block">
                                <div class="submitted d-flex flex-row align-items-start">
                                    @if (!commonDataService.isOneTime) {
                                        <label class="label-as-container">
                                            <span class="title me-2" translate>To:</span>

                                            <app-tags-input
                                                class="flex-fill tags-container me-1"
                                                identifyBy="email"
                                                placeholder="{{ 'Who do you want to send this reply to?' | translate }}"
                                                displayBy="label"
                                                [separatorKeys]="separatorKeys"
                                                [noResultMessage]="'This recipient is unknown to us.' | translate"
                                                [selectedItems]="toUsers"
                                                [items]="users"
                                                [addOnBlur]="true"
                                                [contentType]="'users'"
                                                [addingValidator]="isEmailValid"
                                                [isNotFromListAllowed]="true"
                                                [typeaheadGroupField]="'typeName'"
                                                (add)="
                                                    recipientsUpdate.next({
                                                        to: toUsers,
                                                        cc: parent.ccUsers,
                                                        bcc: parent.bccUsers,
                                                    })
                                                "
                                                (delete)="
                                                    recipientsUpdate.next({
                                                        to: toUsers,
                                                        cc: parent.ccUsers,
                                                        bcc: parent.bccUsers,
                                                    })
                                                ">
                                            </app-tags-input>
                                        </label>

                                        <button
                                            class="btn btn-icon"
                                            ngxClipboard
                                            [cbContent]="toUsers | arrayToString: 'email'">
                                            <sb-inline-svg
                                                class="icon"
                                                aria-label="My icon"
                                                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Copy icon.svg'"
                                                [tooltip]="'Copied' | translate"
                                                [tooltipFadeDuration]="1000"
                                                [triggers]="''"
                                                #toUsersTooltip="bs-tooltip"
                                                (click)="toUsersTooltip.show(); toUsersTooltip.hide()"
                                                container="body">
                                            </sb-inline-svg>
                                        </button>
                                    }

                                    @if (commonDataService.isOneTime) {
                                        <span class="title me-2" translate>To:</span>

                                        <span class="send-to-email flex-fill truncate">
                                            {{ ticket.firstMessageCreator.name }}
                                        </span>
                                    }

                                    <div class="email-controls-container d-flex align-items-center">
                                        <a
                                            [hidden]="isShowCcField || ticket.defaultReplyRecipients.cc.length"
                                            [ngClass]="{ 'ms-1': !commonDataService.isOneTime }"
                                            (click)="showAndFocusCcField()"
                                            class="email-controls-link">
                                            Cc
                                        </a>
                                        <a
                                            [hidden]="isShowBccField"
                                            (click)="showAndFocusBccField()"
                                            class="email-controls-link ms-1">
                                            Bcc
                                        </a>
                                        @if (!commonDataService.isOneTime) {
                                            <a
                                                [hidden]="isShowFromField"
                                                (click)="showAndFocusFromField()"
                                                class="email-controls-link ms-1">
                                                From
                                            </a>
                                        }
                                    </div>
                                </div>
                                @if (isShowCcField || ticket.defaultReplyRecipients.cc.length) {
                                    <div class="submitted d-flex flex-row align-items-start mt-2">
                                        <label class="label-as-container">
                                            <span class="title me-2" translate>Cc:</span>
                                            <app-tags-input
                                                class="flex-fill tags-container me-1"
                                                identifyBy="email"
                                                placeholder="{{ 'Select users' | translate }}"
                                                displayBy="label"
                                                contentType="users"
                                                [noResultMessage]="'This recipient is unknown to us.' | translate"
                                                [selectedItems]="parent.ccUsers"
                                                [items]="users"
                                                [addOnBlur]="true"
                                                [addingValidator]="isEmailValid"
                                                [separatorKeys]="separatorKeys"
                                                [isNotFromListAllowed]="true"
                                                [typeaheadGroupField]="'typeName'"
                                                (add)="
                                                    recipientsUpdate.next({
                                                        to: toUsers,
                                                        cc: parent.ccUsers,
                                                        bcc: parent.bccUsers,
                                                    })
                                                "
                                                (delete)="
                                                    recipientsUpdate.next({
                                                        to: toUsers,
                                                        cc: parent.ccUsers,
                                                        bcc: parent.bccUsers,
                                                    })
                                                ">
                                            </app-tags-input>
                                        </label>

                                        <button
                                            class="btn btn-icon"
                                            ngxClipboard
                                            [cbContent]="parent.ccUsers | arrayToString: 'email'">
                                            <sb-inline-svg
                                                class="icon"
                                                aria-label="My icon"
                                                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Copy icon.svg'"
                                                [tooltip]="'Copied' | translate"
                                                [tooltipFadeDuration]="1000"
                                                [triggers]="''"
                                                #ccUsersTooltip="bs-tooltip"
                                                (click)="ccUsersTooltip.show(); ccUsersTooltip.hide()"
                                                container="body">
                                            </sb-inline-svg>
                                        </button>
                                    </div>
                                }
                                @if (isShowBccField) {
                                    <div class="submitted d-flex flex-row align-items-start mt-2">
                                        <label class="label-as-container">
                                            <span class="title me-2" translate>Bcc:</span>
                                            <app-tags-input
                                                class="flex-fill tags-container me-1"
                                                identifyBy="email"
                                                placeholder="{{ 'Select users' | translate }}"
                                                displayBy="label"
                                                contentType="users"
                                                [noResultMessage]="'This recipient is unknown to us.' | translate"
                                                [selectedItems]="parent.bccUsers"
                                                [items]="users"
                                                [addOnBlur]="true"
                                                [addingValidator]="isEmailValid"
                                                [separatorKeys]="separatorKeys"
                                                [isNotFromListAllowed]="true"
                                                [typeaheadGroupField]="'typeName'"
                                                (add)="
                                                    recipientsUpdate.next({
                                                        to: toUsers,
                                                        cc: parent.ccUsers,
                                                        bcc: parent.bccUsers,
                                                    })
                                                "
                                                (delete)="
                                                    recipientsUpdate.next({
                                                        to: toUsers,
                                                        cc: parent.ccUsers,
                                                        bcc: parent.bccUsers,
                                                    })
                                                ">
                                            </app-tags-input>
                                        </label>

                                        <button
                                            class="btn btn-icon"
                                            ngxClipboard
                                            [cbContent]="parent.bccUsers | arrayToString: 'email'">
                                            <sb-inline-svg
                                                class="icon"
                                                aria-label="My icon"
                                                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Copy icon.svg'"
                                                [tooltip]="'Copied' | translate"
                                                [tooltipFadeDuration]="1000"
                                                [triggers]="''"
                                                #bccUsersTooltip="bs-tooltip"
                                                (click)="bccUsersTooltip.show(); bccUsersTooltip.hide()"
                                                container="body">
                                            </sb-inline-svg>
                                        </button>
                                    </div>
                                }

                                @if (isShowFromField) {
                                    <div class="submitted d-flex flex-row align-items-start mt-2">
                                        <label class="label-as-container">
                                            <span class="title me-2" translate>From:</span>
                                            <ng-template #customItemTemplate let-model="item" let-index="index">
                                                <div class="d-flex align-items-center mt-1 mb-1">
                                                    <div class="truncate">
                                                        <div class="truncate text-light">
                                                            <span class="truncate-name">
                                                                {{ model | truncate: 33 }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-template>
                                            <div
                                                class="tags-input-container form-control d-flex flex-wrap me-1"
                                                [ngClass]="{ 'ng-invalid': '' }">
                                                @if (selectedOutboundEmailAddresses.length) {
                                                    <div class="tag truncate">
                                                        <span class="tag-text truncate">{{
                                                            selectedOutboundEmailAddresses[0]
                                                        }}</span>
                                                        <sb-inline-svg
                                                            class="icon icon-close"
                                                            role="button"
                                                            [attr.aria-label]="'Remove email' | translate"
                                                            (click)="removeOutboundEmailAddress()"
                                                            [url]="
                                                                '/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'
                                                            ">
                                                        </sb-inline-svg>
                                                    </div>
                                                } @else {
                                                    <input
                                                        #outboundEmailAddressSelector="ngModel"
                                                        autocomplete="off"
                                                        class="typeahead-input"
                                                        [placeholder]="'Outbound email address' | translate"
                                                        [typeaheadMinLength]="0"
                                                        [typeaheadSelectFirstItem]="false"
                                                        [typeaheadIsFirstItemActive]="false"
                                                        [typeahead]="commonDataService.outboundEmailAddresses"
                                                        [typeaheadScrollable]="true"
                                                        [typeaheadOptionsInScrollableView]="4"
                                                        [typeaheadItemTemplate]="customItemTemplate"
                                                        [(ngModel)]="selectedOutboundEmailAddress"
                                                        (typeaheadOnSelect)="addOutboundEmailAddress($event)"
                                                        (keydown)="keyDownHandler($event)"
                                                        (blur)="checkAndAddNewEmail()"
                                                        maxlength="1000" />
                                                }
                                            </div>
                                        </label>
                                    </div>
                                }
                            </div>
                        }
                        <div class="smile-field-container" id="new-reply">
                            @if (
                                !commonDataService.isOneTime &&
                                replyTemplateService.allReplyTemplates.length &&
                                parent.quillEditors['newReply']
                            ) {
                                <sb-quill-reply-templates
                                    [quillEditor]="parent.quillEditors['newReply']"
                                    [reply]="ticket.constraints.areReplyAttachmentsAllowed ? newReply : null">
                                </sb-quill-reply-templates>
                            }
                            <app-web-reply-quill-editor
                                [id]="'ticket-thread-web-editor'"
                                [reply]="newReply"
                                (replyChanged)="onReplyChanged($event)"
                                (editorCreated)="parent.onEditorCreated($event, 'newReply')">
                            </app-web-reply-quill-editor>
                            <sb-quill-emoji-picker
                                (updateQuillSelection)="parent.updateQuillSelection(parent.quillEditors['newReply'])"
                                (emojiSelect)="
                                    parent.replyTemplateManagerService.chooseReplyTemplate({
                                        $event: $event.$event,
                                        templateText: $event.emoji,
                                        quillEditor: parent.quillEditors['newReply'],
                                        quillRange: parent.quillRange,
                                        isSmile: true,
                                    })
                                ">
                            </sb-quill-emoji-picker>
                        </div>
                        <div class="attachments-block mb-2">
                            @for (attachment of newReply.attachments; track attachment; let idx = $index) {
                                <sb-file-preview
                                    class="file-container"
                                    [attachment]="attachment"
                                    [fileIndex]="idx"
                                    [canBeRemoved]="true"
                                    [attachments]="newReply.attachments"
                                    [permalink]="ticket.permalink">
                                </sb-file-preview>
                            }
                            <div class="clearfix"></div>
                        </div>
                    </div>
                    <div
                        class="d-flex justify-content-end"
                        [ngClass]="{
                            'justify-content-between':
                                commonDataService.community === 'demo' || commonDataService.community === 'berghansen',
                        }">
                        @if (commonDataService.community === 'demo' || commonDataService.community === 'berghansen') {
                            <div class="mt-2">
                                @if (!commonDataService.isOneTime) {
                                    <label
                                        class="checkbox__label checkbox__label--size-small min-width-50 me-3"
                                        for="isLogged"
                                        tooltip="{{
                                            'This email will be logged on the contact record with the same email in your CRM'
                                                | translate
                                        }}">
                                        {{ 'Log' | translate }}
                                        <input
                                            type="checkbox"
                                            id="isLogged"
                                            name="isLogged"
                                            [(ngModel)]="isShouldBeLoggedInCrm" />
                                        <span class="checkbox__checkmark"></span>
                                    </label>
                                }
                            </div>
                        }
                        <div class="buttons-panel text-end mt-0">
                            @if (!commonDataService.isOneTime) {
                                <button
                                    class="btn btn-icon"
                                    (click)="
                                        parent.openReplyTemplatesModal(
                                            $event,
                                            parent.quillEditors['newReply'],
                                            ticket.constraints.areReplyAttachmentsAllowed ? newReply : null
                                        )
                                    "
                                    tooltip="{{ 'Insert a saved template' | translate }}"
                                    container="body">
                                    <sb-inline-svg
                                        class="icon"
                                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Copy icon.svg'">
                                    </sb-inline-svg>
                                </button>
                            }
                            <button
                                (click)="parent.setSignature(newReply.message, null, $event, false)"
                                class="btn btn-icon"
                                id="btn-signature"
                                tooltip="{{ 'Signature' | translate }}"
                                container="body">
                                <sb-inline-svg
                                    class="icon"
                                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Pen icon.svg'">
                                </sb-inline-svg>
                            </button>
                            @if (ticket.isEditable && ticket.constraints.areReplyAttachmentsAllowed) {
                                <button
                                    class="btn btn-icon"
                                    (click)="
                                        parent.openAttachmentsModal(
                                            newReply.attachments,
                                            newReply.attachments.length,
                                            ticket.constraints.maxReplyAttachmentsCount
                                        )
                                    "
                                    tooltip="{{ 'Attachments' | translate }}"
                                    container="body">
                                    <sb-inline-svg
                                        class="icon"
                                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Attachment icon.svg'">
                                    </sb-inline-svg>
                                </button>
                            }
                            @if (!commonDataService.isOneTime) {
                                <button
                                    class="btn mt-1 mb-1 btn-outline"
                                    [disabled]="
                                        newReply.message
                                            | isInvalidMessage
                                                : ticket.constraints
                                                : !!newReply.attachments.length
                                                : true
                                    "
                                    (click)="
                                        isOnlyAutoSignatureSet && addAutoSignature();
                                        parent.addReply(
                                            newReply,
                                            true,
                                            false,
                                            parent.ccUsers,
                                            parent.bccUsers,
                                            toUsers,
                                            undefined,
                                            undefined,
                                            undefined,
                                            undefined,
                                            selectedOutboundEmailAddresses[0]
                                        )
                                    "
                                    translate>
                                    save as draft
                                </button>
                            }
                            @if (
                                commonDataService.customerSettings.isCustomerReplyPortalEnabled &&
                                !commonDataService.isOneTime
                            ) {
                                <button
                                    [disabled]="
                                        newReply.message
                                            | isInvalidMessage
                                                : ticket.constraints
                                                : !!newReply.attachments.length
                                                : true
                                    "
                                    class="btn mt-1 mb-1 btn-reply-link"
                                    (click)="
                                        isOnlyAutoSignatureSet && addAutoSignature();
                                        parent.addReply(
                                            newReply,
                                            false,
                                            false,
                                            parent.ccUsers,
                                            parent.bccUsers,
                                            toUsers,
                                            null,
                                            isShouldBeLoggedInCrm,
                                            null,
                                            true,
                                            selectedOutboundEmailAddresses[0]
                                        )
                                    ">
                                    <sb-inline-svg
                                        class="icon ps-0"
                                        aria-label="Link icon"
                                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Link icon 2.svg'">
                                    </sb-inline-svg>
                                    <span translate>send reply-link </span>
                                </button>
                            }
                            @if (
                                commonDataService.customerSettings.isCustomerReplyPortalEnabled &&
                                !commonDataService.isOneTime
                            ) {
                                <button
                                    [disabled]="
                                        newReply.message
                                            | isInvalidMessage
                                                : ticket.constraints
                                                : !!newReply.attachments.length
                                                : true
                                    "
                                    class="btn mt-1 mb-1 btn-reply-link"
                                    (click)="
                                        isOnlyAutoSignatureSet && addAutoSignature();
                                        parent.addReply(
                                            newReply,
                                            false,
                                            true,
                                            parent.ccUsers,
                                            parent.bccUsers,
                                            toUsers,
                                            null,
                                            isShouldBeLoggedInCrm,
                                            null,
                                            true,
                                            selectedOutboundEmailAddresses[0]
                                        )
                                    ">
                                    <sb-inline-svg
                                        class="icon ps-0"
                                        aria-label="Link icon"
                                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Link icon 2.svg'">
                                    </sb-inline-svg>
                                    <span translate>send reply-link and close</span>
                                </button>
                            }
                            @if (!ticket.constraints.isOnlySendReplyAsLinkAllowed) {
                                <div class="d-inline-block">
                                    <button
                                        class="btn btn-outline"
                                        [disabled]="
                                            newReply.message
                                                | isInvalidMessage
                                                    : ticket.constraints
                                                    : !!newReply.attachments.length
                                                    : true
                                        "
                                        (click)="
                                            isOnlyAutoSignatureSet && addAutoSignature();
                                            parent.addReply(
                                                newReply,
                                                false,
                                                false,
                                                parent.ccUsers,
                                                parent.bccUsers,
                                                toUsers,
                                                null,
                                                isShouldBeLoggedInCrm,
                                                undefined,
                                                undefined,
                                                selectedOutboundEmailAddresses[0]
                                            )
                                        "
                                        translate>
                                        send
                                    </button>
                                </div>
                            }
                            @if (!ticket.constraints.isOnlySendReplyAsLinkAllowed) {
                                <div class="d-inline-block">
                                    <button
                                        class="btn btn-outline"
                                        [disabled]="
                                            newReply.message
                                                | isInvalidMessage
                                                    : ticket.constraints
                                                    : !!newReply.attachments.length
                                                    : true
                                        "
                                        (click)="
                                            isOnlyAutoSignatureSet && addAutoSignature();
                                            parent.addReply(
                                                newReply,
                                                false,
                                                true,
                                                parent.ccUsers,
                                                parent.bccUsers,
                                                toUsers,
                                                null,
                                                isShouldBeLoggedInCrm,
                                                undefined,
                                                undefined,
                                                selectedOutboundEmailAddresses[0]
                                            )
                                        "
                                        translate>
                                        send and close
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                }
                <div class="clearfix"></div>
            </div>
        </div>
    }
</div>
